import { Box, Stack } from "@mui/material";
// import { ChipsItems } from "../../helper";
import Cards from "components/MyActivityComponents/Cards";
import Chip from "components/MyActivityComponents/Chip";
import { useGetAllOrderRelatedSubsQuery } from "api/order";
import { useState } from "react";
import Alltypes from "./Alltypes";
import Subscription from "./Subscription";
const ChipsItems = [
  { label: "All Types", id: "1" },
  { label: "Subscription", id: "2" },
  { label: "Single Order", id: "3" },
];

const MyActvity = () => {
  // const { data: order, isLoading } = useGetAllOrderRelatedSubsQuery();
  const [activeChip, setActiveChip] = useState(1); // Default active chip is "All Types"
  const isLoading = false


  const handleChipClick = (id) => {
    setActiveChip(id);
  };

  const order = [{
    img: "https://picsum.photos/200",
    label: "Personal subscription",
    heading: "Baked Fish Fillets with Cheese Sauce",
    address: "Chef Juna Food, 4474 Bridge",
    date: "12 Oct -12 Nov 2021",
    chipColor: "#7B49E5",
  }, {
    img: "https://picsum.photos/200",
    label: "Personal subscription",
    heading: "Baked Fish Fillets with Cheese Sauce",
    address: "Chef Juna Food, 4474 Bridge",
    date: "12 Oct -12 Nov 2021",
    chipColor: "#7B49E5",
  }]

  return isLoading ? (
    <p>Loading...</p>
  ) : (
    <>
      <Stack spacing={1} direction="row">
        {ChipsItems.map((item) => (
          <Chip
            key={item.id}
            label={item.label}
            onClick={() => handleChipClick(item.id)}
            id={item.id}
          />
        ))}
      </Stack>
      <Box sx={{ mt: 3 }}>
        {activeChip == 1 && <Alltypes />}
        {activeChip == 2 && <Subscription />}
        {activeChip == 3 && <Alltypes />}
      </Box>

    </>
  );
};

export default MyActvity;
